(function () {
  'use strict';

  var MODAL_ID = 'spm-enquiry-modal';

  // One modal, three flows. All post flat JSON to the Vercel app, which creates the
  // contact AND the deal in the right pipeline (deal creation isn't available in
  // HubSpot Starter workflows, so it runs server-side). See docs/hubspot-forms-setup.md §7.
  var VERCEL_BASE = 'https://spm-internal-tools.vercel.app';
  var ENDPOINTS = {
    enquiry:            VERCEL_BASE + '/api/forms/enquiry',
    price_upon_request: VERCEL_BASE + '/api/forms/enquiry', // same endpoint; segmented by form_type
    preorder:           VERCEL_BASE + '/api/forms/preorder'
  };

  // Fields sent per flow. These go to the Vercel endpoint, which forwards most of them
  // to the matching HubSpot form — and the v3 submit API rejects an entire submission
  // over one field the form does not declare. So anything added here that IS echoed must
  // exist on the form first.
  //
  // `price_amount` is the exception and must stay one: it feeds the deal's native
  // `amount` property server-side and is deliberately absent from ENQUIRY_FORM_FIELDS /
  // PREORDER_FORM_FIELDS. Adding it to either HubSpot form is not a fix, it is how you
  // break every confirmation email at once.
  // `company_website` is the honeypot: rendered off-screen, empty for every human,
  // filled by bots. Like `price_amount` it is deliberately absent from the two
  // *_FORM_FIELDS lists below, so it is never echoed to a HubSpot form — the Vercel
  // endpoint reads it, drops the submission and stops there.
  var BASE = ['firstname', 'lastname', 'email', 'phone', 'country',
              'watch_reference', 'watch_name', 'watch_line', 'source_page_url', 'form_type',
              'price_amount', 'company_website'];
  var FIELDS = {
    enquiry:            BASE.concat(['message']),
    price_upon_request: BASE.concat(['message']),
    preorder:           BASE.concat(['personalisation_note', 'price', 'edition',
                                     'deposit_percentage'])
  };

  // Per-flow copy. {t} is replaced with the product title.
  var COPY = {
    enquiry: {
      title: 'Enquiry',
      intro: 'Leave us a message regarding the {t}. Our team will respond within 24 hours.',
      submit: 'Send enquiry',
      successTitle: 'Thank you for your enquiry',
      successBody: 'We look forward to assisting you.'
    },
    price_upon_request: {
      title: 'Request price',
      intro: 'Request the price and availability of {t}. Our team will be in touch within 24 hours.',
      submit: 'Request price',
      successTitle: 'Thank you',
      successBody: 'Our team will be in touch within 24 hours.'
    },
    preorder: {
      title: 'Pre-order request',
      intro: 'Register your interest in the {t}.',
      submit: 'Submit pre-order request',
      successTitle: 'Pre-order request received',
      successBody: 'Our team will review the details and contact you shortly with confirmation and a secure deposit payment link.'
    }
  };

  var currentType = 'enquiry';

  function endpointFor(type) {
    return ENDPOINTS[type] || ENDPOINTS.enquiry;
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function $(sel, root) { return (root || document).querySelector(sel); }

  function productTitle() {
    var modal = document.getElementById(MODAL_ID);
    return (modal && modal.getAttribute('data-product-title')) || 'this timepiece';
  }

  // Apply flow-specific config: form_type, copy, and pre-order field visibility.
  function applyType(type) {
    if (!ENDPOINTS[type]) type = 'enquiry';
    currentType = type;
    var copy = COPY[type];
    var title = productTitle();

    var ftInput = document.querySelector('#spm-enquiry-form input[name="form_type"]');
    if (ftInput) ftInput.value = type;

    var titleEl = document.getElementById('spm-modal-title');
    if (titleEl) titleEl.textContent = copy.title;

    var introEl = document.querySelector('#spm-enquiry-modal .spm-enquiry-intro');
    if (introEl) introEl.textContent = copy.intro.replace('{t}', title);

    var submitEl = document.querySelector('#spm-enquiry-form .spm-enquiry-submit');
    if (submitEl) submitEl.textContent = copy.submit;

    var sTitle = document.querySelector('#spm-enquiry-modal .spm-success-title');
    if (sTitle) sTitle.textContent = copy.successTitle;
    var sBody = document.querySelector('#spm-enquiry-modal .spm-form-success p:not(.spm-success-title)');
    if (sBody) sBody.textContent = copy.successBody;

    var preFields = document.querySelector('#spm-enquiry-modal [data-preorder-fields]');
    if (preFields) preFields.hidden = (type !== 'preorder');

    // The Message block is enquiry-only. `message` is not in FIELDS.preorder, so on a
    // pre-order it was collecting text that the payload then dropped — a collector could
    // type a request into a visible box and have it silently discarded. Shown for both
    // enquiry and price_upon_request, which do send it.
    var enqFields = document.querySelectorAll('#spm-enquiry-modal [data-enquiry-field]');
    Array.prototype.forEach.call(enqFields, function (el) { el.hidden = (type === 'preorder'); });
  }

  function setSourceUrl() {
    var el = document.querySelector('#spm-enquiry-form input[name="source_page_url"]');
    if (el) el.value = window.location.href;
  }

  function clearErrors(form) {
    form.querySelectorAll('.spm-field-error').forEach(function (e) { e.textContent = ''; });
    form.querySelectorAll('.spm-field.has-error').forEach(function (e) { e.classList.remove('has-error'); });
    var err = document.querySelector('#spm-enquiry-modal .spm-form-error');
    if (err) err.hidden = true;
  }

  function showFieldError(form, name, message) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return;
    var field = input.closest('.spm-field');
    if (field) field.classList.add('has-error');
    var msg = form.querySelector('[data-error-for="' + name + '"]');
    if (msg) msg.textContent = message;
  }

  function resetForm() {
    var form = document.getElementById('spm-enquiry-form');
    if (!form) return;
    form.reset();
    form.hidden = false;
    clearErrors(form);
    var success = document.querySelector('#spm-enquiry-modal .spm-form-success');
    if (success) success.hidden = true;
    setSourceUrl();
  }

  function validate(form) {
    clearErrors(form);
    var ok = true;
    var firstname = form.firstname.value.trim();
    var lastname = form.lastname.value.trim();
    var email = form.email.value.trim();

    if (!firstname) { showFieldError(form, 'firstname', 'Required'); ok = false; }
    if (!lastname) { showFieldError(form, 'lastname', 'Required'); ok = false; }
    if (!email) {
      showFieldError(form, 'email', 'Required'); ok = false;
    } else if (!EMAIL_RE.test(email)) {
      showFieldError(form, 'email', 'Enter a valid email'); ok = false;
    }
    return ok;
  }

  function buildPayload(form) {
    var names = FIELDS[currentType] || FIELDS.enquiry;
    var out = {};
    names.forEach(function (n) {
      var input = form.elements[n];
      out[n] = input ? input.value : '';
    });
    return out;
  }

  async function submitForm(e) {
    e.preventDefault();
    var form = e.currentTarget;
    if (!validate(form)) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Sending…'; }

    try {
      var res = await fetch(endpointFor(currentType), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildPayload(form))
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      form.hidden = true;
      var success = document.querySelector('#spm-enquiry-modal .spm-form-success');
      if (success) success.hidden = false;
    } catch (err) {
      var errEl = document.querySelector('#spm-enquiry-modal .spm-form-error');
      if (errEl) errEl.hidden = false;
    } finally {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.label || 'Send enquiry'; }
    }
  }

  // Selected variant, tracked because the hidden watch_reference and price fields
  // are server-rendered from the first variant only. 12 watches ship in 38mm and
  // 42mm with a different SKU and a different price per size, so without this the
  // drawer reports the 38mm piece whatever the collector picked.
  var currentVariantId = null;

  // Prestige dispatches variant:change on the product form with bubbles: true, so
  // one listener on document covers every product template.
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    currentVariantId = variant.id;
    syncVariant();
  });

  // CHF list price per variant, in cents, for the HubSpot deal amount.
  //
  // The hidden `price` field carries what the collector was actually shown, and that is
  // the presentment currency of their market — CHF in Switzerland, EUR in France, USD in
  // the US. The HubSpot portal is single-currency CHF, so none of those can be written to
  // a deal amount as-is, and Liquid cannot ask for the shop-currency price once a market
  // applies. `/products/<handle>.js?country=CH` returns the CH market's prices in cents
  // from any market (verified 2026-08-20), so one credential-free request gets the figure.
  //
  // Fetched once per page, when the drawer is first opened rather than on load: it is only
  // needed if someone actually enquires. A failure leaves the field empty and the deal is
  // created with no amount, which is the previous behaviour and better than a wrong one.
  var chfPrices = null;
  var chfPending = false;

  function loadChfPrices() {
    if (chfPrices || chfPending) return;
    var modal = document.getElementById(MODAL_ID);
    var url = modal && modal.dataset.productUrl;
    if (!url) return;
    chfPending = true;
    fetch(url + '.js?country=CH', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;
        chfPrices = {};
        product.variants.forEach(function (v) { chfPrices[String(v.id)] = v.price; });
        syncAmount();
      })
      .catch(function () { /* leave price_amount empty — no amount beats a wrong amount */ });
  }

  // Kept apart from syncVariant(): that one bails when no variant:change has fired yet,
  // which is every single-variant product (buckles, straps, the CPO piece). The amount
  // still has to be filled for those, from the server-rendered variant id.
  function syncAmount() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || !chfPrices) return;
    var input = modal.querySelector('input[name="price_amount"]');
    if (!input) return;
    var cents = chfPrices[String(currentVariantId || modal.dataset.variantId)];
    input.value = cents == null ? '' : String(cents);
  }

  // Must run AFTER resetForm(): form.reset() restores the HTML defaults, which are
  // the first variant's values.
  function syncVariant() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || !currentVariantId) return;

    var mapEl = modal.querySelector('[data-spm-variants]');
    if (!mapEl) return;

    var entry;
    try {
      entry = JSON.parse(mapEl.textContent)[String(currentVariantId)];
    } catch (err) {
      return; // malformed map: leave the server-rendered values rather than guess
    }
    if (!entry) return;

    var ref = modal.querySelector('input[name="watch_reference"]');
    var price = modal.querySelector('input[name="price"]');
    var name = modal.querySelector('input[name="watch_name"]');
    if (ref && entry.sku) ref.value = entry.sku;
    if (price && entry.price) price.value = entry.price;
    if (name && entry.name) name.value = entry.name;
    if (entry.sku) modal.dataset.productSku = entry.sku;
    syncAmount();
  }

  document.addEventListener('DOMContentLoaded', function () {
    setSourceUrl();
    var form = document.getElementById('spm-enquiry-form');
    if (form) form.addEventListener('submit', submitForm);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[aria-controls="' + MODAL_ID + '"]');
    if (!btn) return;

    // resetForm() first (form.reset() restores HTML defaults incl. form_type),
    // then applyType() overlays the flow-specific config.
    resetForm();
    applyType(btn.dataset.form || 'enquiry');
    syncVariant(); // re-apply the selected size, which form.reset() just wiped
    loadChfPrices(); // no-op after the first open; calls syncAmount() when it lands
    syncAmount();    // form.reset() wiped this one too
    // x-modal opens via aria-controls — theme's DialogElement handles this
  });
})();

/* ===================================================================
   Speake Up — Template B (editorial) image/text pairing.
   On articles whose body layout is "editorial", wrap each image together
   with the paragraph immediately before it into an alternating side-by-side
   pair. Standalone paragraphs, images, headings and quotes stay full-width.
   Works on both bare <img> and the rich-text editor's <p><img></p>.
   =================================================================== */
(function () {
  function imgInside(el) {
    if (!el) return null;
    if (el.tagName === 'IMG') return el;
    if (el.tagName === 'P') {
      var imgs = el.querySelectorAll('img');
      if (imgs.length === 1 && el.textContent.trim() === '') return imgs[0];
    }
    return null;
  }

  function isTextPara(el) {
    return el && el.tagName === 'P' && !imgInside(el) && el.textContent.trim().length > 0;
  }

  function pairEditorial(prose) {
    var nodes = Array.prototype.slice.call(prose.children);
    var count = 0;

    nodes.forEach(function (node) {
      var img = imgInside(node);
      if (!img) return;

      // Collect the whole run of text paragraphs immediately before the image,
      // back to the last heading / image / pair. Keeps an image beside the full
      // block of text it belonged to (the WordPress block), not one stray line.
      var texts = [];
      var cursor = node.previousElementSibling;
      while (isTextPara(cursor)) {
        texts.unshift(cursor);
        cursor = cursor.previousElementSibling;
      }
      if (!texts.length) return; // standalone image → stays full-width

      // Pull a leading sub-heading into the text column too, so the block's
      // subtitle sits beside its image (as it did in WordPress).
      if (cursor && /^H[2-6]$/.test(cursor.tagName)) {
        texts.unshift(cursor);
      }

      var pair = document.createElement('div');
      pair.className = 'article-pair' + (count % 2 === 1 ? ' article-pair--reversed' : '');

      var textWrap = document.createElement('div');
      textWrap.className = 'article-pair__text';
      var mediaWrap = document.createElement('div');
      mediaWrap.className = 'article-pair__media';

      prose.insertBefore(pair, texts[0]);
      texts.forEach(function (t) { textWrap.appendChild(t); });
      mediaWrap.appendChild(img);
      pair.appendChild(textWrap);
      pair.appendChild(mediaWrap);

      // drop the now-empty <p> that wrapped the image (editor output)
      if (node.tagName === 'P' && node.textContent.trim() === '' && !node.querySelector('img')) {
        node.remove();
      }
      count++;
    });
  }

  function init() {
    var list = document.querySelectorAll('.article__wrapper[data-article-layout="editorial"] .prose');
    Array.prototype.forEach.call(list, pairEditorial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ════════════════════════════════════════════════════════════════
   Our Calibres — grid: drawer reveal + scroll-in (BL-030)
   Each .cal-card carries a hidden .cal-sheet; on "More information" we
   clone it into a single shared right-hand drawer. Drawer-only (the
   design's expand/modal variants are not shipped).
   ════════════════════════════════════════════════════════════════ */
(function () {
  /* Init on any page that renders a calibre sheet — the grid page OR a watch PDP (BL-042). */
  if (!document.querySelector('.cal-sheet')) return;

  var grid = document.querySelector('.calibre-grid .cal-grid'); /* null on the PDP */

  var CLOSE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';

  /* shared scrim + drawer, created once */
  var scrim = document.createElement('div');
  scrim.className = 'cal-scrim';
  var drawer = document.createElement('aside');
  drawer.className = 'cal-drawer';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.innerHTML = '<button class="cal-panel-close" type="button" aria-label="Close">' + CLOSE_ICON + '</button><div class="cal-drawer-scroll"></div>';
  document.body.appendChild(scrim);
  document.body.appendChild(drawer);
  var drawerScroll = drawer.querySelector('.cal-drawer-scroll');

  var isOpen = false;

  function esc(id) { return (window.CSS && CSS.escape) ? CSS.escape(id) : id; }

  function sheetById(id) {
    return id ? document.querySelector('.cal-sheet[data-sheet-id="' + esc(id) + '"]') : null;
  }

  function clearOpenMark() {
    var open = document.querySelector('.cal-card.is-open');
    if (open) open.classList.remove('is-open');
  }

  function close() {
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    document.body.classList.remove('cal-locked');
    clearOpenMark();
    isOpen = false;
  }

  function openSheet(sheet) {
    if (!sheet) return;
    drawerScroll.innerHTML = sheet.innerHTML;
    drawerScroll.scrollTop = 0;
    scrim.classList.add('open');
    requestAnimationFrame(function () { drawer.classList.add('open'); });
    document.body.classList.add('cal-locked');
    clearOpenMark();
    var card = sheet.closest('.cal-card');
    if (card) card.classList.add('is-open');
    isOpen = true;
  }

  /* click delegation (document-level) */
  document.addEventListener('click', function (e) {
    /* grid card trigger — [data-id] inside .calibre-grid */
    var g = e.target.closest('.calibre-grid [data-id]');
    if (g) { openSheet(sheetById(g.getAttribute('data-id'))); return; }

    /* explicit PDP trigger — [data-cal-open="<handle>"] */
    var p = e.target.closest('[data-cal-open]');
    if (p) { e.preventDefault(); openSheet(sheetById(p.getAttribute('data-cal-open'))); return; }

    /* PDP trigger — the image-with-text "Discover more" button linking to #calibre.
       The PDP renders exactly one calibre sheet, so open that one. */
    var link = e.target.closest('a[href$="#calibre"]');
    if (link) { e.preventDefault(); openSheet(document.querySelector('.cal-sheet[data-sheet-id]')); return; }
  });

  scrim.addEventListener('click', close);
  drawer.querySelector('.cal-panel-close').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  /* scroll-reveal for cards (staggered per row) — grid page only */
  if (grid) {
    var columnCount = function () {
      return getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    };
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.cal-card'));
    if (window.IntersectionObserver && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = cards.indexOf(en.target);
          en.target.style.transitionDelay = Math.min((i % columnCount()) * 70, 210) + 'ms';
          en.target.classList.add('in');
          io.unobserve(en.target);
        });
      }, { threshold: 0.1 });
      cards.forEach(function (c) { io.observe(c); });
      /* safety net: never leave a card stuck hidden */
      setTimeout(function () {
        cards.forEach(function (c) {
          if (!c.classList.contains('in') && c.getBoundingClientRect().top < window.innerHeight) c.classList.add('in');
        });
      }, 1600);
    } else {
      cards.forEach(function (c) { c.classList.add('in'); });
    }
  }
})();

/* ============================================================
   Warranty Extension form (BL-043)
   Bespoke form → multipart POST to the Vercel endpoint (file uploads).
   Endpoint URL comes from the section's data-endpoint attribute.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('[data-spm-we]');
  if (!section) return;
  var form = document.getElementById('spm-we-form');
  if (!form) return;

  var endpoint = section.getAttribute('data-endpoint') || '';
  var formWrap = section.querySelector('[data-we-formwrap]');
  var successEl = section.querySelector('[data-we-success]');
  var errorEl = form.querySelector('.spm-we-error');
  var srcInput = form.querySelector('[data-we-source]');
  if (srcInput) srcInput.value = window.location.href;

  /* preferred-language "Other" reveal */
  var langSel = form.querySelector('[data-we-lang]');
  var langOther = form.querySelector('[data-we-lang-other]');
  if (langSel && langOther) {
    langSel.addEventListener('change', function () {
      var other = langSel.value === 'Other';
      langOther.hidden = !other;
      langOther.required = other;
      if (!other) langOther.value = '';
    });
  }

  /* file tiles — show chosen filename */
  section.querySelectorAll('[data-we-file]').forEach(function (tile) {
    var input = tile.querySelector('input[type="file"]');
    var name = tile.querySelector('[data-we-filename]');
    if (!input) return;
    if (name && !name.dataset.placeholder) name.dataset.placeholder = name.textContent;
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (file) {
        if (name) name.textContent = file.name;
        tile.classList.add('is-set');
      } else {
        if (name) name.textContent = name.dataset.placeholder || '';
        tile.classList.remove('is-set');
      }
    });
  });

  function showError(show) { if (errorEl) errorEl.hidden = !show; }

  function resetForm() {
    form.reset();
    section.querySelectorAll('[data-we-file]').forEach(function (tile) {
      tile.classList.remove('is-set');
      var name = tile.querySelector('[data-we-filename]');
      if (name && name.dataset.placeholder) name.textContent = name.dataset.placeholder;
    });
    if (langOther) { langOther.hidden = true; langOther.required = false; }
    if (successEl) successEl.hidden = true;
    if (formWrap) formWrap.hidden = false;
    showError(false);
  }

  var resetBtn = section.querySelector('[data-we-reset]');
  if (resetBtn) resetBtn.addEventListener('click', resetForm);

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    showError(false);
    if (!form.checkValidity()) { form.reportValidity(); return; }
    if (!endpoint) { showError(true); return; }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }

    try {
      var res = await fetch(endpoint, { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      if (formWrap) formWrap.hidden = true;
      if (successEl) successEl.hidden = false;
      try { window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' }); } catch (e2) {}
    } catch (err) {
      showError(true);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Submit Warranty Extension Request'; }
    }
  });
})();

/* ============================================================
   SpeakEasy Membership form (BL-044)
   Same mechanism as the warranty handler above, scoped to [data-spm-sm].
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('[data-spm-sm]');
  if (!section) return;
  var form = document.getElementById('spm-sm-form');
  if (!form) return;

  var endpoint = section.getAttribute('data-endpoint') || '';
  var formWrap = section.querySelector('[data-sm-formwrap]');
  var successEl = section.querySelector('[data-sm-success]');
  var errorEl = form.querySelector('.spm-sm-error');
  var srcInput = form.querySelector('[data-sm-source]');
  if (srcInput) srcInput.value = window.location.href;

  /* file tile — show chosen filename */
  section.querySelectorAll('[data-sm-file]').forEach(function (tile) {
    var input = tile.querySelector('input[type="file"]');
    var name = tile.querySelector('[data-sm-filename]');
    if (!input) return;
    if (name && !name.dataset.placeholder) name.dataset.placeholder = name.textContent;
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (file) {
        if (name) name.textContent = file.name;
        tile.classList.add('is-set');
      } else {
        if (name) name.textContent = name.dataset.placeholder || '';
        tile.classList.remove('is-set');
      }
    });
  });

  function showError(show) { if (errorEl) errorEl.hidden = !show; }

  function resetForm() {
    form.reset();
    section.querySelectorAll('[data-sm-file]').forEach(function (tile) {
      tile.classList.remove('is-set');
      var name = tile.querySelector('[data-sm-filename]');
      if (name && name.dataset.placeholder) name.textContent = name.dataset.placeholder;
    });
    if (successEl) successEl.hidden = true;
    if (formWrap) formWrap.hidden = false;
    showError(false);
  }

  var resetBtn = section.querySelector('[data-sm-reset]');
  if (resetBtn) resetBtn.addEventListener('click', resetForm);

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    showError(false);
    if (!form.checkValidity()) { form.reportValidity(); return; }
    if (!endpoint) { showError(true); return; }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }

    try {
      var res = await fetch(endpoint, { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      if (formWrap) formWrap.hidden = true;
      if (successEl) successEl.hidden = false;
      try { window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' }); } catch (e2) {}
    } catch (err) {
      showError(true);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Submit Request'; }
    }
  });
})();

/* Signed-in account avatar: recolor the Shop-Pay ring to brand navy.
   The ring uses --shop-brand-color, pinned at the element level inside the
   shopify-account shadow DOM (host/theme CSS can't reach it), so set it on
   the .account-button--shop-customer element directly. Coin fill + initials
   are handled by CSS custom properties in custom.css. */
(function () {
  var NAVY = '#003087';
  function brand(acc) {
    if (!acc || !acc.shadowRoot) return;
    var el = acc.shadowRoot.querySelector('.account-button--shop-customer');
    if (el && el.style.getPropertyValue('--shop-brand-color') !== NAVY) {
      el.style.setProperty('--shop-brand-color', NAVY);
    }
  }
  function run() {
    document.querySelectorAll('shopify-account').forEach(function (acc) {
      brand(acc);
      if (acc.shadowRoot && !acc.__spmObserved) {
        acc.__spmObserved = true;
        new MutationObserver(function () { brand(acc); })
          .observe(acc.shadowRoot, { childList: true, subtree: true });
      }
    });
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  var tries = 0;
  var iv = setInterval(function () { run(); if (++tries > 20) clearInterval(iv); }, 300);
})();

/* PDP price disclosure (BL-035): the watch price disclaimer sits in a
   details/summary so it opens on click and works on touch, where hover
   does not exist. details gives us open/close and keyboard access for
   free; it does not close when you click elsewhere, so add that plus
   Escape, which is what people expect from a popover. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('.spm-price-disclosure[open]').forEach(function (d) {
      if (d !== except) d.open = false;
    });
  }

  document.addEventListener('click', function (event) {
    var open = document.querySelector('.spm-price-disclosure[open]');
    if (!open) return;
    if (!open.contains(event.target)) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (d.matches && d.matches('.spm-price-disclosure') && d.open) closeAll(d);
  }, true);
})();

/* ============================================================
   Contact form (BL-046)
   Bespoke form → JSON POST to the Vercel endpoint, which echoes the submission to a
   HubSpot form. No files, so JSON rather than the multipart the warranty form uses.
   Endpoint URL comes from the section's data-endpoint attribute.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('[data-spm-cf]');
  if (!section) return;
  var form = document.getElementById('spm-cf-form');
  if (!form) return;

  var endpoint = section.getAttribute('data-endpoint') || '';
  var formWrap = section.querySelector('[data-cf-formwrap]');
  var successEl = section.querySelector('[data-cf-success]');
  var errorEl = form.querySelector('.spm-cf-error');
  var srcInput = form.querySelector('[data-cf-source]');
  if (srcInput) srcInput.value = window.location.href;

  /* ?subject= preselects the dropdown, so a collector arriving from the Services page or the
     Watch Certificate band does not have to restate where they came from. Matched loosely
     (case and surrounding space) because the value travels through a URL and the subject
     wording is a client-editable setting — an exact-match-only lookup would break the day
     Madelyne renames a subject and the link still carries the old one. Unknown values fall
     through to the placeholder rather than guessing. */
  var subjectSel = form.querySelector('[name="contact_subject"]');
  if (subjectSel) {
    var wanted = new URLSearchParams(window.location.search).get('subject');
    if (wanted) {
      var norm = function (s) { return String(s).trim().toLowerCase(); };
      Array.prototype.some.call(subjectSel.options, function (opt) {
        if (opt.value && norm(opt.value) === norm(wanted)) { subjectSel.value = opt.value; return true; }
        return false;
      });
    }
  }

  function showError(show) { if (errorEl) errorEl.hidden = !show; }

  function resetForm() {
    form.reset();
    if (srcInput) srcInput.value = window.location.href;
    if (successEl) successEl.hidden = true;
    if (formWrap) formWrap.hidden = false;
    showError(false);
  }

  var resetBtn = section.querySelector('[data-cf-reset]');
  if (resetBtn) resetBtn.addEventListener('click', resetForm);

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    showError(false);
    if (!form.checkValidity()) { form.reportValidity(); return; }
    if (!endpoint) { showError(true); return; }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }

    try {
      var payload = {};
      new FormData(form).forEach(function (value, key) { payload[key] = value; });
      var res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      if (formWrap) formWrap.hidden = true;
      if (successEl) successEl.hidden = false;
      form.reset();
      window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' });
    } catch (err) {
      // The endpoint returns non-2xx when the message reached nobody, so an error here
      // means exactly that. Never show the success panel on a failure: the collector
      // would walk away believing the Maison has their message.
      showError(true);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Send Message'; }
    }
  });
})();
